module.exports = __webpack_public_path__ + "static/media/finance.ba70b83b.svg";